import { QueryClient } from '@tanstack/react-query'

// Tag types for query invalidation
export const TAG_TYPES = {
  SCHEDULE: 'SCHEDULE',
  PERRITOS: 'PERRITOS',
} as const

// Singleton QueryClient instance
let browserQueryClient: QueryClient | undefined

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
        gcTime: 1000 * 60 * 10, // 10 minutes (previously cacheTime)
        retry: 3,
        refetchOnWindowFocus: false,
        retryDelay: 0,
      },
    },
  })
}

// Get or create QueryClient instance
export function getQueryClient() {
  // Server: always make a new query client
  if (typeof window === 'undefined') {
    return makeQueryClient()
  }

  // Browser: make a new query client if we don't already have one
  // This is very important, so we don't re-make a new client if React
  // suspends during the initial render. This may not be needed if we
  // have a suspense boundary BELOW the creation of the query client
  if (!browserQueryClient)
    browserQueryClient = makeQueryClient()
  return browserQueryClient
}

// Strapi API base URL
export const STRAPI_URL = process.env.NEXT_PUBLIC_STRAPI_URL || 'http://localhost:1337'
